export enum ERequestStepsAccreditationStatus {
  waiting = 'DOCUMENT_WAITING',
  processing = 'DOCUMENT_CHECKING',
  sign = 'SIGN',
  active = 'ACTIVE',
}
